/* eslint-disable global-require */
import React, { useState, useEffect } from 'react';
import { AiFillStar, AiOutlineFork } from 'react-icons/ai';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { Container } from './styles';
import api from '../../services/api';

interface Case {
  full_name: string;
  html_url: string;
  description: string;
  stargazers_count: number;
  forks_count: number;
  language: string;
}

const Cases: React.FC = () => {
  const [cases, setCases] = useState<Case[]>([] as Case[]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData(): Promise<void> {
      const response = await api.get('/repos');

      const sortedData = response.data
        .sort((a: Case, b: Case) => b.stargazers_count - a.stargazers_count)
        .slice(0, 6);

      setCases(sortedData);
      setLoading(false);
    }

    loadData();
  }, []);

  return (
    <>
      {loading && (
        <SkeletonTheme color="#2222" highlightColor="#3333">
          <Container
            horizontal
            className="scroll-container"
            hideScrollbars={false}
          >
            <div className="case">
              <Skeleton width={320} height={35} count={1} />
              <Skeleton width={300} count={2} />
            </div>
            <div className="case">
              <Skeleton width={320} height={35} count={1} />
              <Skeleton width={300} count={2} />
            </div>
            <div className="case">
              <Skeleton width={320} height={35} count={1} />
              <Skeleton width={300} count={2} />
            </div>
            <div className="case">
              <Skeleton width={320} height={35} count={1} />
              <Skeleton width={300} count={2} />
            </div>
          </Container>
        </SkeletonTheme>
      )}

      {!loading && (
        <Container
          horizontal
          className="scroll-container"
          hideScrollbars={false}
        >
          {cases.map(caseItem => (
            <a
              className="case"
              key={caseItem.full_name}
              href={caseItem.html_url}
              target="blank"
            >
              <div className="case-details">
                <h2>{caseItem.full_name}</h2>
                <p>{caseItem.description}</p>

                <div>
                  <span>{caseItem.language}</span>

                  <div className="stars">
                    {caseItem.stargazers_count > 0 && (
                      <>
                        <AiFillStar size={15} color="#EDD75E" />
                        {caseItem.stargazers_count}
                      </>
                    )}

                    {caseItem.forks_count > 0 && (
                      <>
                        <AiOutlineFork size={15} color="#5EEDDC" />
                        {caseItem.forks_count}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </a>
          ))}
        </Container>
      )}
    </>
  );
};

export default Cases;
